module.exports = __webpack_public_path__ + "img/12手机.08287165.png";